import AllowMergedViewServiceRequest from '../data/schema/AllowMergedViewServiceRequest';
import { makePostRequest } from 'owa-ows-gateway';
import getTimeProfileRestEndpoint from '../utils/getTimeProfileRestEndpoint';
import { trace } from 'owa-trace';
import { createRestApiRequestHeaders } from 'owa-headers';

export default async function allowMergedViewService(
    allowMergedViewServiceRequest: AllowMergedViewServiceRequest,
    mergedViewEnabledAccount: string
) {
    return createRestApiRequestHeaders(mergedViewEnabledAccount).then(headers => {
        return makePostRequest(
            getTimeProfileRestEndpoint('AllowMergedView'),
            allowMergedViewServiceRequest /* requestObject */,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            headers /* customheaders */
        )
            .then(async (response: any) => {
                return response;
            })
            .catch((error: any) => {
                trace.error(error);
                return error;
            });
    });
}
